import React, { useEffect } from "react"
import css from "./InstallInstructionsModal.module.scss"

// iOS' Share glyph — a square with an arrow escaping through the top edge —
// is the universal visual cue Safari uses for "Add to Home Screen", so it's
// what people recognize from the real menu.
function ShareIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M12 3v12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path
        d="M7.5 7.5 12 3l4.5 4.5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 10h-.75A2.25 2.25 0 0 0 3 12.25v6.5A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75v-6.5A2.25 2.25 0 0 0 18.75 10H18"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

// Chrome/Android's overflow menu — the vertical "⋮" — is where "Install app"
// / "Add to Home screen" lives on Android.
function OverflowMenuIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="12" cy="5.5" r="1.6" fill="currentColor" />
      <circle cx="12" cy="12" r="1.6" fill="currentColor" />
      <circle cx="12" cy="18.5" r="1.6" fill="currentColor" />
    </svg>
  )
}

export default function InstallInstructionsModal({ onClose }) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose()
    }
    window.addEventListener("keydown", handleKeyDown)
    return () => window.removeEventListener("keydown", handleKeyDown)
  }, [onClose])

  return (
    <div className={css.overlay} onClick={onClose}>
      <div className={css.card} onClick={(event) => event.stopPropagation()}>
        <button type="button" className={css.close} onClick={onClose} aria-label="Close">
          ×
        </button>
        <h2 className={css.title}>Install IGLA as an app</h2>

        <div className={css.platform}>
          <div className={css.icon}>
            <ShareIcon />
          </div>
          <h3 className={css.platformTitle}>iPhone / iPad (Safari)</h3>
          <ol className={css.steps}>
            <li>Tap the Share icon in Safari&rsquo;s toolbar</li>
            <li>Scroll down and tap &ldquo;Add to Home Screen&rdquo;</li>
            <li>Tap &ldquo;Add&rdquo; to confirm</li>
          </ol>
        </div>

        <div className={css.platform}>
          <div className={css.icon}>
            <OverflowMenuIcon />
          </div>
          <h3 className={css.platformTitle}>Android (Chrome)</h3>
          <ol className={css.steps}>
            <li>Tap the menu icon in the top-right corner</li>
            <li>Tap &ldquo;Install app&rdquo; (or &ldquo;Add to Home screen&rdquo;)</li>
            <li>Confirm by tapping &ldquo;Install&rdquo;</li>
          </ol>
        </div>
      </div>
    </div>
  )
}
